module.exports = __webpack_public_path__ + "assets/img/32_532_big.ae31f37a.jpg";